// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"../../App.css\"","appBlue":"#137cef","btn":"CustomButton_btn__3D0G6"};